import React, { memo } from "react";
import { MAMenuCopyrightWrapper } from "./style";
import { kt_copyrightText } from "../../../../../common/constants";

const KTMAMenuCopyright = memo(() => {
  return <MAMenuCopyrightWrapper>{kt_copyrightText()}</MAMenuCopyrightWrapper>;
});

export default KTMAMenuCopyright;
